;(function ($) {
  $(function () {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const numberContainers =
            document.querySelectorAll('.number-container')
          numberContainers.forEach((container) => {
            if (!container.classList.contains('animate')) {
              container.classList.add('animate')
              const digits = container.querySelectorAll('.digit')
              digits.forEach((digit, index) => {
                setTimeout(() => {
                  digit.classList.add('animate')
                }, index * 50)
              })
            }
          })
          observer.unobserve(entry.target)
        }
      })
    }, observerOptions)

    const numberContainers = document.querySelectorAll('.number-container')
    numberContainers.forEach((container) => {
      observer.observe(container)
    })

    objectFitImages()

    if (window.location.hash) {
      const hash = window.location.hash
      const element = $(hash)
      if (element.length) {
        $('html, body').animate(
          {
            scrollTop: element.offset().top - 150,
          },
          0
        )
      }
    }

    Fancybox.bind('[data-fancybox]', {
      Toolbar: {
        display: {
          left: ['infobar'],
          middle: [
            'zoomIn',
            'zoomOut',
            'toggle1to1',
            'rotateCCW',
            'rotateCW',
            'flipX',
            'flipY',
          ],
          right: ['slideshow', 'download', 'thumbs', 'close'],
        },
      },
    })

    $('.js-go-to-open-positions').on('click', function (e) {
      e.preventDefault()

      $('html, body').animate(
        {
          scrollTop: $('.js-carrier-open-positions').offset().top - 250,
        },
        300
      )
    })

    const gutter = $(window).width() > 991 ? 64 : 16

    var $grid = $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.card-result',
      gutter: gutter,
      fitWidth: true,
      horizontalOrder: true,
      transitionDuration: 0,
    })

    $(window).resize(function () {
      $grid.masonry('layout')
    })

    $(document).on('click', '.js-tour-link', function (e) {
      e.preventDefault()
      const href = $(this).attr('href')

      if (!href) {
        return
      }

      if (!$('#js-3dtour-modal').length) {
        return
      }

      $('#js-3dtour-modal').iziModal({
        iframe: true,
        headerColor: '#000000',
        iframeHeight: '100vh',
        width: '100vw',
        iframeURL: href,
        closeButton: true,
        onClosed: function () {
          $('#js-3dtour-modal').iziModal('destroy')
        },
      })

      $('header').addClass('scrolled')
      $('#js-3dtour-modal').iziModal('open')
    })

    $(document).on('click', '.js-close-virtual-tour-modal', function (e) {
      const navHeight = nav.outerHeight()
      if ($(window).scrollTop() <= navHeight) {
        $('header').removeClass('scrolled')
      }
    })

    $('.js-menu-toggle').on('click', function (e) {
      e.preventDefault()
      $('.menu-wrapper').toggleClass('open')
      $('.js-menu-toggle').toggleClass('open')
      $('body').toggleClass('of-hidden')
    })

    $(window).on('resize', function () {
      if ($(window).width() > 991) {
        $('.menu-wrapper').removeClass('open')
        $('.js-menu-toggle').removeClass('open')
        $('body').removeClass('of-hidden')

        $grid.masonry({ gutter: 64 })
      } else {
        $grid.masonry({ gutter: 16 })
      }
    })

    const nav = $('header')
    const navHeight = nav.outerHeight()
    if ($(window).width() > 1199) {
      if ($(window).scrollTop() >= navHeight) {
        nav.addClass('scrolled')
      } else {
        nav.removeClass('scrolled')
      }
    }

    $(window).scroll(function () {
      const nav = $('header')
      const navHeight = nav.outerHeight()
      if ($(window).scrollTop() >= navHeight) {
        nav.addClass('scrolled')
      } else {
        nav.removeClass('scrolled')
      }
    })

    $('.js-show-more-params').on('click', function (e) {
      e.preventDefault()

      $('.technical-param').each(function (index, element) {
        if (!$(element).is(':visible')) {
          $(element).addClass('show')
        }
      })

      $(this).hide()
    })

    const switchProjectsMap = function () {
      if ($(window).width() < 992) {
        $('.section-results').insertAfter('.section-projects-map')
      } else {
        $('.section-projects-map').insertAfter('.section-results')
      }
    }

    switchProjectsMap()

    $(window).on('resize', function () {
      switchProjectsMap()
    })

    if ($(window).width() > 1199) {
      $('.js-card-park-description').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      })

      $('.js-park-card').matchHeight({
        property: 'min-height',
        target: null,
        remove: false,
      })
    }

    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    // Számformázás: visszahelyezzük a pontokat és vesszőt a tizedesjegyhez
    function formatNumber(num) {
      // A tizedesjegy miatt szétválasztjuk az egész és tizedes részt
      var parts = num.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') // Ezeres csoportosítás
      return parts.length > 1 ? parts.join(',') : parts[0] // Ha van tizedesjegy, vesszővel kapcsoljuk össze, ha nincs, csak az egész szám
    }

    // Számok animálása
    function animateNumbers() {
      $('.js-anim-numbers').each(function () {
        var $this = $(this)
        if (isElementInViewport(this) && !$this.hasClass('animated')) {
          $this.addClass('animated')

          // Eredeti szám lekérése, pontok és vessző eltávolítása
          var targetNumber = parseFloat(
            $this.text().replace(/\./g, '').replace(',', '.')
          ) // Pontokat vesszük és vesszőből pontot csinálunk a float értékhez

          $({ countNum: 0 }).animate(
            { countNum: targetNumber },
            {
              duration: 2000,
              easing: 'swing',
              step: function () {
                // Ha egész szám, nincs tizedesjegy, ha tört, akkor mutatjuk a tizedesjegyeket
                if (Math.floor(targetNumber) === targetNumber) {
                  $this.text(formatNumber(Math.floor(this.countNum)))
                } else {
                  $this.text(formatNumber(this.countNum.toFixed(1))) // Csak akkor mutatunk tizedesjegyet, ha tört szám
                }
              },
              complete: function () {
                if (Math.floor(targetNumber) === targetNumber) {
                  $this.text(formatNumber(Math.floor(this.countNum)))
                } else {
                  $this.text(formatNumber(this.countNum.toFixed(1)))
                }
              },
            }
          )
        }
      })
    }

    $(window).on('scroll', animateNumbers)
    animateNumbers()
  })
})(jQuery)
